import {
  REFRESH_USER_BALANCES_START,
  REFRESH_USER_BALANCES_SUCCESS,
  REFRESH_USER_BALANCES_FAILED,
} from 'constants/action-types/user/refreshUserBalances';

export default (state, { type, payload }) => {
  switch (type) {
    case REFRESH_USER_BALANCES_START:
      return {
        ...state,
        refreshUserBalances: {
          ...state.refreshUserBalances,
          loading: true,
          error: null,
          message: null,
        },
      };
    case REFRESH_USER_BALANCES_SUCCESS:
      return {
        ...state,
        refreshUserBalances: {
          ...state.refreshUserBalances,
          message: payload.message,
          error: null,
          loading: false,
        },
      };
    case REFRESH_USER_BALANCES_FAILED:
      return {
        ...state,
        refreshUserBalances: {
          ...state.refreshUserBalances,
          loading: false,
          error: payload,
          message: null,
        },
      };
    default:
      return null;
  }
};
